<template>
  <div :id="id" :style="`width: 100%; height: 100%; min-height: ${height}px; min-width: 200px;`"></div>
</template>

<script>
import { formatarUnidades } from '@/produto/common/functions/numeric';
import loadChart from './loadChart';

export default {
  name: 'GraficoBarrasVerticais',
  props: {
    id: {
      type: String,
      required: true,
    },
    categoryField: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    valueField: {
      type: String,
      required: true,
    },
    dados: {
      type: Array,
      required: true,
    },
    showExport: {
      type: Boolean,
      default: false,
    },
    colors: {
      type: Array,
      default: () => ['#878787'],
    },
    height: {
      type: Number,
    },
  },
  watch: {
    dados() {
      this.montarGrafico();
    },
  },
  data() {
    return {
      isReady: false,
      chartInstance: null,
      chartConfig: {
        type: 'serial',
        theme: 'light',
        dataProvider: [],
        categoryField: this.categoryField,
        columnSpacing: 8,
        titles: [{
          color: '#1B5499',
          text: this.title,
          size: 24,
        }],
        valueAxes: [{
          position: 'left',
          gridAlpha: 0,
          axisAlpha: 0,
          axisThickness: 0,
          gridThickness: 0,
          autoGridCount: false,
          gridCount: 4,
          minimum: 0,
          labelFunction: (value) => formatarUnidades(value),
        }],
        categoryAxis: {
          gridPosition: 'start',
          gridAlpha: 0,
          axisAlpha: 0,
          axisThickness: 0,
          gridThickness: 0,
          tickPosition: 'start',
          labelRotation: 0,
          fontSize: 14,
          color: '#666666',
        },
        graphs: [],
        colors: this.colors,
        numberFormatter: {
          precision: 2,
          decimalSeparator: ',',
          thousandsSeparator: '.',
        },
      },
    };
  },
  methods: {
    montarGrafico() {
      if (typeof AmCharts === 'undefined' || !this.isReady) return;
      if (!this.dados || this.dados.length === 0) return;

      if (this.chartInstance && this.chartInstance.clear) {
        this.chartInstance.clear();
      }

      this.chartConfig.dataProvider = this.dados;
      this.chartConfig.categoryField = this.categoryField;
      this.chartConfig.colors = this.colors;
      this.chartConfig.titles[0].text = this.title;
      this.chartConfig.categoryAxis.labelRotation = 0;

      const maxValue = Math.max(...this.dados.map((item) => item[this.valueField] || 0));
      const maxValueWithMargin = maxValue > 0 ? maxValue * 1.05 : maxValue;

      this.chartConfig.valueAxes[0].maximum = maxValueWithMargin;

      this.chartConfig.graphs = [{
        valueField: this.valueField,
        type: 'column',
        fillAlphas: 0.8,
        lineAlpha: 0.2,
        fixedColumnWidth: 35,
        balloonFunction(graphDataItem) {
          const value = graphDataItem.values.value || 0;
          const { mesExtensoAno } = graphDataItem.dataContext || {};
          const formattedValue = AmCharts.formatNumber(value, {
            precision: 2,
            decimalSeparator: ',',
            thousandsSeparator: '.',
          });
          return `
            <div style="font-size:14px; text-align:left">
              <span><b>${mesExtensoAno || graphDataItem.category}</b></span><br>
              <span>R$: ${formattedValue}</span>
            </div>`;
        },
        labelText: '[[value]]',
        labelFunction(item) {
          const valor = item && item.values && item.values.value ? item.values.value : 0;
          return formatarUnidades(valor);
        },
        labelPosition: 'top',
        fontSize: 12,
      }];

      this.chartConfig.export = {
        enabled: this.showExport && !!(this.dados && this.dados.length > 0),
        fileName: this.title,
        pageOrigin: false,
        menu: [{
          class: 'export-main',
          menu: ['JPG', 'PNG', 'PDF'],
        }],
      };

      const chartInstance = AmCharts.makeChart(this.id, this.chartConfig);
      this.chartInstance = chartInstance;

      this.$nextTick(() => {
        chartInstance.validateNow();
      });
    },
  },
  mounted() {
    window.addEventListener('AmChartCarregado', () => {
      this.isReady = true;
    });
  },
  beforeMount() {
    loadChart().then(() => {
      window.dispatchEvent(new Event('AmChartCarregado'));
      this.montarGrafico();
    });
  },
  beforeDestroy() {
    this.chartInstance.clear();
  },
};
</script>
